import React from 'react';
import { generatePath, Link } from 'react-router';

import DefaultErrorDescription from '../Errors/Components/DefaultErrorDescription';
import ErrorDialog from '../Errors/Components/ErrorDialog';
import RoutePath from '@/Routing/RoutePath';
import UIStrings from '@/Utils/UIStrings';

interface EmailIntegrationOauthErrorProps {
    companyId: string | null;
    oauthErrorCode: string | null;
    oauthErrorDescription: string | null;
}

const EmailIntegrationOauthError = ({
    companyId,
    oauthErrorCode,
    oauthErrorDescription,
}: EmailIntegrationOauthErrorProps): React.ReactNode => {
    const errorTitle = 'Email Integration Failed';
    const errorDescription = oauthErrorDescription || 'An error occurred during email integration. Please try again.';

    const nextPageRoute = companyId
        ? generatePath(RoutePath.AccountSettingsIntegrations, { companyId })
        : generatePath(RoutePath.Root);

    const isOAuthConsentError = oauthErrorCode && Number(oauthErrorCode) === 45002;

    return (
        <ErrorDialog
            errorTitle={errorTitle}
            errorBody={
                <div className="flex flex-col gap-2">
                    {isOAuthConsentError ? (
                        <>
                            <p className="text-foreground text-base leading-relaxed">
                                {UIStrings.EmailIntegrationOAuthConsentErrorMessage}
                            </p>
                            <p className="text-foreground text-base leading-relaxed font-bold">{UIStrings.NextSteps}</p>
                            <ul className="flex list-disc flex-col gap-2 pl-6">
                                <li className="list-item">
                                    <p className="text-foreground text-base leading-relaxed font-bold">
                                        {UIStrings.TryAgainApprovePermissions1}
                                    </p>
                                    <p className="text-foreground text-base leading-relaxed">
                                        {UIStrings.TryAgainApprovePermissions2}
                                    </p>
                                </li>
                                <li className="list-item">
                                    <p className="text-foreground text-base leading-relaxed font-bold">
                                        {UIStrings.ContactYourITAdministrator1}
                                    </p>
                                    <p className="text-foreground text-base leading-relaxed">
                                        {UIStrings.ContactYourITAdministrator2}
                                    </p>
                                </li>
                            </ul>
                            <p className="text-foreground mt-4 text-base leading-relaxed">
                                <Link to={nextPageRoute} className="text-primary hover:text-primary/80 underline">
                                    {UIStrings.GoBack}
                                </Link>
                            </p>
                        </>
                    ) : (
                        <DefaultErrorDescription errorDescription={errorDescription} />
                    )}
                </div>
            }
        />
    );
};

export default EmailIntegrationOauthError;
